// client/src/config/dialpadBranches.ts

/**
 * Branch-to-SMS phone number mapping for Dialpad.
 * Used by both the SMS proxy Cloud Function and the client SMS compose UI.
 * All numbers are in E.164 format.
 */

export interface BranchSmsNumber {
  label: string;
  phoneNumber: string;
}

/** Array format for FromSelector component */
export const BRANCH_SMS_NUMBERS: readonly BranchSmsNumber[] = [
  { label: 'Tracy', phoneNumber: '+12092291990' },
  { label: 'Reno', phoneNumber: '+17753449940' },
  { label: 'Seaside', phoneNumber: '+18313751463' },
] as const;

/** Legacy record format for getBranchSmsNumber */
const BRANCH_SMS_RECORD: Record<string, string> = {
  'Tracy': '+12092291990',
  'Reno': '+17753449940',
  'Seaside': '+18313751463',
};

/**
 * Look up the Dialpad SMS number for a branch.
 * Supports exact match and partial (case-insensitive) match.
 *
 * @param branch - Branch name (e.g. "Tracy", "Reno", "Seaside")
 * @returns E.164 phone number or undefined if no match
 */
export function getBranchSmsNumber(branch: string): string | undefined {
  return BRANCH_SMS_RECORD[branch] ?? Object.entries(BRANCH_SMS_RECORD)
    .find(([key]) => branch.toLowerCase().includes(key.toLowerCase()))?.[1];
}

/**
 * Reverse lookup: find the branch name for a given E.164 phone number.
 * Returns the first matching branch name for a given phone number.
 *
 * @param phoneNumber - E.164 phone number (e.g. "+12092291990")
 * @returns Branch name or undefined if no match
 */
export function getBranchForNumber(phoneNumber: string): string | undefined {
  return Object.entries(BRANCH_SMS_RECORD).find(([, num]) => num === phoneNumber)?.[0];
}

/** Realm ID → default department phone number */
export const REALM_DEFAULT_FROM_NUMBER: Record<string, string> = {
  '9130356161043966': '+18313751463', // OnPoint → Seaside
  '9341452597659805': '+12092291990', // PowerGen → Tracy
};
